import { LayoutSpacerSmall } from '@pendwa/common-browser/components/LayoutSpacerSmall/index.js';
import { getCloudinaryUrl } from '@pendwa/common/utils/getCloudImageUrl.js';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

export interface ITileItem {
  key: string;
  title: string;
  path: string;
  image_path: string;
}

export const Tile: React.FC<{
  item: ITileItem;
}> = (props) => {
  return (
    <LayoutSpacerSmall>
      <div
        className={clsx(
          'group relative block aspect-square w-full cursor-pointer overflow-hidden rounded-lg bg-gray-100'
        )}
      >
        <Link to={props.item.path} className={'block h-full w-full'}>
          <img
            src={getCloudinaryUrl({
              path: props.item.image_path,
              aspect_ratio: 1,
              width: 150,
            })}
            alt={`Watch ${props.item.title}`}
            className={'pointer-events-none object-cover group-hover:opacity-90'}
          />
        </Link>
      </div>

      <h3 className="truncate text-sm font-semibold">{props.item.title}</h3>
    </LayoutSpacerSmall>
  );
};
